

TagServiceProvider = ($q, $http, $location, $state, ApiUrl, TagNotificationService) ->
    'ngInject'

    rootUrl = ApiUrl.partial('tag')

    @getTagUrl = -> $state.current.data?.tagUrl
    @hasUrlTags  = -> @getTagUrl()?

    deleteRequest = (url, data) ->
        return $http
            url: url
            method: 'DELETE'
            data: data
            headers: 'Content-Type': 'application/json'

    @getParamsFromUrl = ->
        params = $location.search()
        @getTagUrl().addDefaults(params)
        return params


    @lookupTags = (params, root) ->
        url = if root then rootUrl(root, 'index') else rootUrl('index')
        return $http.get(url, params: params)
            .then (response) -> response.data.items


    @paramsToUrl = (params) ->
        @getTagUrl().addEmptyTags(params)
        $state.go('.', params, location: 'replace');
        return

    @create = (slug, name, description, program) ->
        data = 
            slug: slug
            name: name
            description: description
            program_id: program?.id or program or undefined

        return $http.post(rootUrl(), data)
            .then getResponseItem

    @update = (tag, name, description) ->
        tag_id = tag.id or tag
        url = rootUrl(tag_id)
        data = name: name, description: description
        return $http.patch(url, data)
            .then getResponseItem

    @get = (tagId) ->
        return $http.get(rootUrl(tagId))
            .then getResponseItem

    @delete = (tag) ->
        tag_id = tag.id or tag
        url = rootUrl(tag.id)
        return $http.delete(url)

    @validateName = (slug, name, program, existing) ->
        url = rootUrl(slug, 'available')
        params = 
            name: name
            program_id: program?.id or program
            tag_id: existing.id or existing

        return $http.get(url, params: params)
            .then getResponseItem
            .then (tag) ->
                if tag and tag.id != (existing.id or existing)
                then return $q.reject(tag)
                else return tag

    @getEntities = (tag, params={}) ->
        url = rootUrl(tag.id, 'entities')
        return $http.get(url, params: params)

    @getEntityCount = (tag, params={}) ->
        url = rootUrl(tag.id, 'entities', 'count')
        return $http.get(url, params: params)
            .then (r) -> r.data
            
    @setEntityTag = (tag, entity, addTag=true) ->
        if addTag
        then return @tagEntity(tag, entity) 
        else return @untagEntity(tag, entity)

    @tagEntity = (tag, entity) ->
        tag_id = tag.id or tag
        entity_id = entity.id or entity
        url = rootUrl(tag_id, 'entities')
        return $http.post(url, entity_id: entity_id)
            .then TagNotificationService.addResponse

    @tagFiltered = (tag, filters) ->
        tag_id = tag.id or tag
        url = rootUrl(tag_id, 'entities')
        return $http.post(url, filters: filters)
            .then TagNotificationService.addResponse

    @untagEntity = (tag, entity) -> 
        tag_id = tag.id or tag
        entity_id = entity.id or entity
        url = rootUrl(tag_id, 'entities')
        return deleteRequest(url, entity_id: entity_id)
            .then TagNotificationService.addResponse

    @untagFiltered = (tag, filters) ->
        tag_id = tag.id or tag
        url = rootUrl(tag_id, 'entities')
        return deleteRequest(url, filters: filters)
            .then TagNotificationService.addResponse

    return @

getResponseItem = (response) -> response.data.item

module.factory 'TagService', TagServiceProvider
